import React, { useEffect, useState } from 'react';
import api from '../../../../config/axios';

import ConfiguracaoModal from './modals/Configuracao';
import Paginacao from '../../../../components/utils/paginacao';

import { FaPlus, FaEdit, FaTrashAlt, FaArrowLeft, FaFilter } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Configuracoes = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const [configuracoes, setConfiguracoes] = useState([]);
    const [filtroNome, setFiltroNome] = useState('');
    const [filtroAtivo, setFiltroAtivo] = useState('');
    const [selectedConfiguracao, setSelectedConfiguracao] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const limit = 10;

    const fetchConfiguracoes = async (currentPage) => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: currentPage,
                limit: limit,
                nome: filtroNome,
                ativo: filtroAtivo
            };

            const response = await api.get('/configuracoes-financeiras', { params });
            setConfiguracoes(response.data.configuracoes || []);
            setTotalPages((Math.ceil(response.data.totalRegistros / limit)) || 1);
            setTotalRegistros(response.data.totalRegistros || 0);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar os dados. Tente novamente mais tarde.');
        } finally {
            Swal.close();
        }
    };

    useEffect(() => {
        fetchConfiguracoes(currentPage);
    }, [currentPage]);

    const handlePageChange = (currentPage) => {
        setCurrentPage(currentPage);
    };

    const handleFiltrar = () => {
        setCurrentPage(1);
        fetchConfiguracoes(1);
    };

    const handleLimparFiltros = () => {
        setFiltroNome('');
        setFiltroAtivo('');
    };

    const handleAddConfiguracao = () => {
        setSelectedConfiguracao(null);
        setIsModalOpen(true);
    };

    const handleEditConfiguracao = (configuracao) => {
        setSelectedConfiguracao(configuracao);
        setIsModalOpen(true);
    };

    const handleDeleteConfiguracao = async (configuracao) => {
        const result = await Swal.fire({
            title: 'Tem certeza?',
            text: `Deseja excluir a configuração "${configuracao.nome}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                await api.delete(`/configuracoes-financeiras/${configuracao.id}`);
                Swal.fire('Excluído!', 'Configuração foi excluída com sucesso.', 'success');
                fetchConfiguracoes(currentPage);
            } catch (error) {
                Swal.fire('Erro!', error.response?.data?.message || 'Não foi possível excluir a configuração.', 'error');
            }
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedConfiguracao(null);
    };

    const handleConfiguracaoAtualizada = () => {
        fetchConfiguracoes(currentPage);
        handleModalClose();
    };

    const getStatusBadge = (ativo) => {
        return ativo ? 'bg-success' : 'bg-secondary';
    };

    const getStatusLabel = (ativo) => {
        return ativo ? 'Ativo' : 'Inativo';
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn btn-outline-secondary me-3"
                                    onClick={() => navigate('/financeiro/cadastros')}
                                    title="Voltar para Cadastros"
                                >
                                    <FaArrowLeft />
                                </button>
                                <h4 className="fw-bold mb-0">Configurações Financeiras</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 mb-3">
                        <div className="col-md-6 col-12">
                            <button className="btn btn-outline-primary" onClick={handleAddConfiguracao}>
                                <FaPlus /> Adicionar Configuração Financeira
                            </button>
                        </div>
                    </div>

                    <div className="row mt-4 mb-4">
                        <div className="col-lg-4 col-12">
                            <label className="form-label fw-bold">Nome</label>
                            <input
                                type="text"
                                autoComplete="off"
                                placeholder="Digite o nome da configuração"
                                value={filtroNome}
                                className="form-control"
                                onChange={(e) => setFiltroNome(e.target.value)}
                            />
                        </div>
                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                            <label className="form-label fw-bold">Status</label>
                            <select
                                value={filtroAtivo}
                                className="form-control"
                                onChange={(e) => setFiltroAtivo(e.target.value)}
                            >
                                <option value="">Todos os status</option>
                                <option value="true">Ativo</option>
                                <option value="false">Inativo</option>
                            </select>
                        </div>
                        <div className="col-lg-5 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                            <div className="d-flex gap-2 w-100 justify-content-end">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={handleLimparFiltros}
                                >
                                    Limpar
                                </button>
                                <button
                                    className="btn btn-custom-primary"
                                    onClick={handleFiltrar}
                                >
                                    <FaFilter /> Filtrar
                                </button>
                            </div>
                        </div>
                    </div>

                    {error ? (
                        <p className="error-message">{error}</p>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead className="table-custom-primary">
                                    <tr>
                                        <th className="text-nowrap">Nome</th>
                                        <th className="text-nowrap">Categoria Comanda</th>
                                        <th className="text-nowrap">Centro Custo Comanda</th>
                                        <th className="text-nowrap">Categoria Comissão</th>
                                        <th className="text-nowrap">Centro Custo Comissão</th>
                                        <th className="text-center">Status</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {configuracoes.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                Nenhuma configuração encontrada.
                                            </td>
                                        </tr>
                                    ) : (
                                        configuracoes.map((config) => (
                                            <tr key={config.id}>
                                                <td className="text-nowrap">{config.nome}</td>
                                                <td className="text-nowrap">{config.comandaCategoriaFinanceira?.nome || '-'}</td>
                                                <td className="text-nowrap">{config.comandaCentroCusto?.nome || '-'}</td>
                                                <td className="text-nowrap">{config.comissaoCategoriaFinanceira?.nome || '-'}</td>
                                                <td className="text-nowrap">{config.comissaoCentroCusto?.nome || '-'}</td>
                                                <td className="text-center">
                                                    <span className={`badge ${getStatusBadge(config.ativo)}`}>
                                                        {getStatusLabel(config.ativo)}
                                                    </span>
                                                </td>
                                                <td className="text-center text-nowrap">
                                                    <button
                                                        className="btn btn-sm btn-custom-secondary"
                                                        onClick={() => handleEditConfiguracao(config)}
                                                        title="Editar"
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-custom-secondary ms-3"
                                                        onClick={() => handleDeleteConfiguracao(config)}
                                                        title="Excluir"
                                                    >
                                                        <FaTrashAlt />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <div className="mb-3">
                            <span>
                                Total de registros: <strong>{totalRegistros}</strong>
                            </span>
                        </div>
                        <Paginacao
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <ConfiguracaoModal
                    configuracao={selectedConfiguracao}
                    onClose={handleModalClose}
                    onConfiguracaoAtualizada={handleConfiguracaoAtualizada}
                />
            )}
        </div>
    );
};

export default Configuracoes; 